const WINDOW = window as { [key: string]: any };

export const reactNativeMessenger = ({
  key,
  data = {}
}: {
  key?: any;
  data: any;
}): void => {
  if (typeof WINDOW !== "undefined") {
    const temp = {
      ...data
    };
    if (key) {
      temp.key = key;
    }
    console.log(temp);

    WINDOW?.ReactNativeWebView?.postMessage(JSON.stringify(temp));
  }
};

export const callReactNativeByParent = ({
  eventKey,
  data
}: {
  eventKey: string;
  data: {};
}): void => {
  const message = JSON.stringify({
    key: "CALL_NATIVE",
    eventKey,
    data: {
      ...data
    }
  });
  window.parent.postMessage(message, "*");
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export function getMobileOperatingSystem(): string {
  var userAgent = navigator.userAgent || navigator.vendor || WINDOW.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !WINDOW.MSStream) {
    return "iOS";
  }

  return "unknown";
}
